<!-- 主播推荐页的国家选择器 -->
<template>
  <div :class="['CountryClassify-Component', { inIndex: inIndex }]">
    <client-only>
      <div class="first-few-list">
        <button
          v-for="(country, index) in firstFewCountries"
          :key="index"
          :class="[
            'country-item',
            { 'country-item__active': country.tabType === currentTabType }
          ]"
          :title="$t(country.title)"
          @click="changeCountry(country.tabType)"
        >
          {{ $t(country.title) }}
        </button>

        <div class="more-list">
          <button class="country-item btn-more-country">
            {{ $t('lang040') }}
          </button>
          <div class="wrapper" :style="{ display: showMore ? '' : 'none' }">
            <div class="more-country-wrapper">
              <div class="continents">
                <i>{{ $t('lang059') }}</i>
              </div>
              <div class="more-country-list">
                <button
                  v-for="(country, index) in moreCountries"
                  :key="index"
                  :title="$t(country.title)"
                  :class="[
                    'country-item',
                    {
                      'country-item__active': country.tabType === currentTabType
                    }
                  ]"
                  @click="changeCountry(country.tabType)"
                >
                  {{ $t(country.title) }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import { firstFewCountries, moreCountries } from './constant';

export default {
  components: {},
  props: {
    currentTabType: {
      type: String,
      default: 'ALL'
    },
    inIndex: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.firstFewCountries = firstFewCountries;
    this.moreCountries = moreCountries;
    return {
      showMore: true
    };
  },
  computed: {},
  created() {},
  methods: {
    changeCountry(tabType) {
      if (this.currentTabType === tabType) return;
      this.showMore = false;
      setTimeout(() => {
        this.showMore = true;
      });

      this.$emit('on-change', tabType);
    }
  }
};
</script>
<style lang="scss" scoped>
.CountryClassify-Component {
  position: relative;
  top: 15px;
  padding-bottom: 30px;
  z-index: 19;
  zoom: 1;

  &::before,
  &:after {
    content: '';
    display: table;
    line-height: 0;
    clear: both;
  }

  &.inIndex {
    top: 2px;
    padding-bottom: 0;
    margin-bottom: -15px;
  }
}

.first-few-list {
  float: left;
  // overflow: hidden;
}

.more-list {
  position: relative;
  float: left;
  width: 90px;
  height: 28px;

  &:hover .wrapper {
    display: block;
  }

  .wrapper {
    position: absolute;
    top: 28px;
    right: -80px;
    display: none;
    padding-top: 16px;
  }

  .more-country-wrapper {
    width: 718px;
    max-height: 596px;
    min-height: 270px;
    padding-top: 30px;
    padding-left: 30px;
    overflow: hidden;
    z-index: 20;
    border-radius: 3px;
    background: #fff;
    border: 1px #e5e5e5 solid;

    &::before {
      content: '';
      position: absolute;
      z-index: 21;
      top: 16px;
      left: 0;
      right: 0;
      height: 2px;
      background: #00ddcc;
    }

    .continents {
      height: 14px;
      margin-bottom: 20px;
      border-left: 3px #00ddcc solid;

      i {
        position: relative;
        top: -2px;
        margin-left: 10px;
        font-size: 16px;
        color: #2e2e2e;
        line-height: 16px;
      }
    }

    .more-country-list {
      overflow: hidden;
    }
  }
}

.country-item {
  float: left;
  min-width: 66px;
  padding: 0 13px;
  height: 30px;
  border-radius: 31px;
  border: 1px solid #e1e3e6;
  font-size: 16px;
  font-weight: 500;
  color: #2f3033;
  line-height: 22px;
  margin-right: 12px;
  margin-bottom: 15px;
  text-align: center;
  background: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &__active,
  &:hover {
    border: 1px #00ddcc solid;
    color: #fff;
    background: linear-gradient(90deg, #2ee6d6 0%, #00d2e5 100%);
  }

  &.btn-more-country {
    display: block;
    position: relative;
    padding-right: 28px;

    &::after {
      content: '';
      width: 14px;
      height: 14px;
      float: right;
      position: absolute;
      top: 7px;
      right: 10px;
      background: url(~@assets/img/icon.png) -11px -420px no-repeat;
    }

    &:hover {
      &::after {
        background: url(~@assets/img/icon.png) -64px -420px no-repeat;
      }
    }
  }
}

// @media (max-width: 1100px) {
//   .more-list {
//     .wrapper {
//       right: -620px;
//     }
//   }
// }
</style>
